import { render } from "./CalendarNavigation.vue?vue&type=template&id=7b3d7112"
import script from "./CalendarNavigation.vue?vue&type=script&lang=ts"
export * from "./CalendarNavigation.vue?vue&type=script&lang=ts"
script.render = render

export default script